import { useObjectState } from 'common/Hooks/UseObjectState'
import { downloadXLSX } from 'common/Utils/downloadUtils'
import { getUserValuesFromLocalStorage } from 'common/Utils/LocalStorageUtilities'
import { formatDateToMMDDYYYY, getDate, getMeasure, isStringInList } from 'common/Utils/StringUtilities'
import Modal from 'components/Common/Modal/Modal'
import { OptionsInput } from 'components/Common/OptionsInput'
import SearchInput from 'components/Common/SearchInput'
import { ProductionStatus } from 'constants/productionStatus'
import { USER_ROLE_SUPPLIER } from 'constants/userRoles'
import DateFilterDropdown from 'pages/Dashboards/CommonComponents/DateFilterDropdown'
import { INITIAL_DATE_RANGE, MONTHS } from 'pages/Dashboards/constants'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { getFilteredProductionsWithPartsInvocingToExport, removeFilteredProductionsWithPartsInvocingToExport } from 'store/actions'

const INITIAL_STATE = {
	availableStatus: [],
}

export const FilterProductionListWihPartsModal = ({
	t, roles, totalImport, removeFilteredProductionsWithPartsInvocingToExport, getFilteredProductionWithPartsInvoicing, keyword, setKeyword, productionListWithPartsInvoicing, setFilters, filters, getFilteredProductionsWithPartsInvocingToExport, productionListWithPartsInvoicingToExport, isLoadingProductionListWithPartsInvoicingToExport, isLoadingProductionListWithPartsInvoicing
}) => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const { objectData, handleOnChange, resetState } = useObjectState(INITIAL_STATE)
	const [dateRange, setDateRange] = useState(INITIAL_DATE_RANGE)
	const [isReadyToDownload, setIsReadyToDownload] = useState(false)


	const handleCloseModal = () => {
		setIsModalOpen(false)
	}

	const isSupplier = () => {
		return isStringInList(USER_ROLE_SUPPLIER, roles) != null
	}


	const productionStatusOptions = [
		{
			value: ProductionStatus.PICKED_UP_BY_COURIER,
			label: <div className={`rounded-pill ${objectData.availableStatus.includes(ProductionStatus.PICKED_UP_BY_COURIER) ? 'w-100' : 'w-50'} text-white bg-purple`}>{t('production_status_3', { ns: 'status' })}</div>,
		},
		{
			value: ProductionStatus.QUALITY_CONTROL,
			label: <div className={`rounded-pill ${objectData.availableStatus.includes(ProductionStatus.QUALITY_CONTROL) ? 'w-100' : 'w-50'} text-white bg-blue`}>{t('production_status_8', { ns: 'status' })}</div>,
		},
		{
			value: ProductionStatus.COMPLETED,
			label: <div className={`rounded-pill ${objectData.availableStatus.includes(ProductionStatus.COMPLETED) ? 'w-100' : 'w-50'} text-white bg-green`}>{t('production_status_6', { ns: 'status' })}</div>,
		},
	]

	const handleApplyFilters = () => {
		const newFilters = {
			...filters,
			availableStatus: objectData.availableStatus,
			productionCreateDate: dateRange,
		}
		setFilters(newFilters)
		setIsModalOpen(false)
	}

	const handleResetFilters = () => {
		resetState()
		setDateRange(INITIAL_DATE_RANGE)
		setFilters({ productionCreateDate: INITIAL_DATE_RANGE, supplierId: isSupplier() ? parseInt(getUserValuesFromLocalStorage().id) : null })
		setIsModalOpen(false)
	}

	useEffect(() => {
		if (dateRange.startDate && dateRange.endDate) {
			const newFilters = {
				...filters,
				productionCreateDate: dateRange,
			}
			if (isSupplier()) {
				newFilters.supplierId = parseInt(getUserValuesFromLocalStorage().id)
			}
			setFilters(newFilters)
		}
	}, [dateRange])


	const getMonthOptions = (t) => {
		const currentDate = new Date()
		const currentYear = currentDate.getFullYear()
		const currentMonth = currentDate.getMonth()
		return Array.from(
			{ length: 12 },
			(_, i) => {
				const monthToRender = currentMonth - i >= 0 ? MONTHS[currentMonth - i] : MONTHS[12 + currentMonth - i]
				const yearToRender = currentMonth - i >= 0 ? currentYear : currentYear - 1
				return {
					optionToRender: `${t(monthToRender, { ns: 'months' })} - ${yearToRender}`,
					dateRange: {
						startDate: formatDateToMMDDYYYY(new Date(currentYear, currentMonth - i, 1)),
						endDate: formatDateToMMDDYYYY(new Date(currentYear, currentMonth - i + 1, 0)),
					},
				}
			},
		)
	}
	useEffect(() => {
		if (productionListWithPartsInvoicingToExport && productionListWithPartsInvoicingToExport.length > 0) {
			setIsReadyToDownload(true)
		}

	}, [productionListWithPartsInvoicingToExport])

	const MONTHS_OPTIONS = getMonthOptions(t)

	const exportExcel = () => {
		getFilteredProductionsWithPartsInvocingToExport(
			keyword,
			filters,
		)
	}

	useEffect(() => {
		if (isReadyToDownload) {

			const addTwoHours = (date) => {
				date.setTime(date.getTime() + 2 * 60 * 60 * 1000)
				const day = String(date.getDate()).padStart(2, '0')
				const month = String(date.getMonth() + 1).padStart(2, '0')
				const year = date.getFullYear()
				const hours = String(date.getHours()).padStart(2, '0')
				const minutes = String(date.getMinutes()).padStart(2, '0')
				const seconds = String(date.getSeconds()).padStart(2, '0')

				return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
			}

			const getStatus = (statusId) => {
				switch (statusId) {
					case ProductionStatus.PICKED_UP_BY_COURIER:
						return t('production_status_3', { ns: 'status' })
					case ProductionStatus.QUALITY_CONTROL:
						return t('production_status_8', { ns: 'status' })
					case ProductionStatus.COMPLETED:
						return t('production_status_6', { ns: 'status' })
					default:
						return 'Desconocido'
				}
			}

			const rows = [
				{
					id: t('Id'),
					productionDate: t('productionDate', { ns: 'naming' }),
					status: t('status', { ns: 'naming' }),
					shipmentProductionDate: t('shipmentProductionDate', { ns: 'naming' }),
					weight: t('weight', { ns: 'naming' }),
					tracking: t('tracking', { ns: 'naming' }),
					import: t('totalPrice', { ns: 'naming' }),
				},
				...productionListWithPartsInvoicingToExport.map((item) => ({
					id: `${item.orderId}-${item.orderFragmentId}`,
					productionDate: addTwoHours(new Date(item.orderDate)),
					status: getStatus(item.statusId),
					shipmentProductionDate: getDate(item.shipmentDateReal),
					weight: getMeasure(item.weight, 'g'),
					tracking: item.shipmentTrackingNumber,
					import: item.totalPrice,
				})),
			]
			downloadXLSX({
				rows,
				fileName: 'productions_export',
			})

			setIsReadyToDownload(false)
			removeFilteredProductionsWithPartsInvocingToExport()
		}
	}, [isReadyToDownload])

	return (
		<div className='d-flex justify-content-between align-items-center'>
			<div className='d-flex align-items-center'>
				<div className="position-relative me-3 mt-2">
					<SearchInput onChange={setKeyword} value={keyword} />
				</div>

				<button className='btn btn-secondary' onClick={() => { setIsModalOpen(true) }}>{t('filter', { ns: 'naming' })}</button>
				<Modal
					title={t('filterProductions', { ns: 'naming' })}
					buttons={[
						<button onClick={() => { handleResetFilters() }} key='reset_production_filters' className='btn btn-primary'>{t('reset', { ns: 'naming' })}</button>,
						<button onClick={() => { handleApplyFilters() }} key='apply_production_filters' className='btn btn-primary'>{t('apply', { ns: 'naming' })}</button>,
					]}
					body={
						<div className='p-4'>
							<OptionsInput
								isMulti
								value={objectData.availableStatus}
								setValue={handleOnChange}
								objectElement='availableStatus'
								title={t('status', { ns: 'naming' })}
								options={productionStatusOptions}
								automaticMappedValue
							/>
						</div>
					}
					isOpen={isModalOpen}
					closeModal={handleCloseModal}
				/>

				<div className='ms-4'>
					<DateFilterDropdown options={MONTHS_OPTIONS} title={t('months', { ns: 'naming' })} dateRange={dateRange} handleOnChangeDate={setDateRange} size={true} />
				</div>
				<button
					className="btn btn-success mx-4" style={{ width: 'auto' }}
					onClick={() => exportExcel()}
					disabled={isLoadingProductionListWithPartsInvoicing || isLoadingProductionListWithPartsInvoicingToExport}
				>
					{t('export_productions', { ns: 'naming' })}
				</button>
			</div>

			<div className="d-flex align-items-center">
				<div className='mx-5 mt-2'>
					<table style={{ borderCollapse: 'collapse' }}>
						<tbody>
							<tr>
								<td style={{ border: '1px solid #000', padding: '5px', borderRadius: '3px', backgroundColor: '#ececec' }}>
									<h5 style={{ margin: 0, fontWeight: '500' }}>{t('total_import', { ns: 'naming' })}:</h5>
								</td>
								<td style={{ border: '1px solid #000', padding: '5px', borderRadius: '3px' }}>
									<h5 style={{ margin: 0, fontWeight: '500' }}>{parseFloat(totalImport.toFixed(2))} €</h5>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	)
}

FilterProductionListWihPartsModal.propTypes = {
	t: PropTypes.func,
	getFilteredProductionWithPartsInvoicing: PropTypes.func,
	isLoadingProductionListWithPartsInvoicing: PropTypes.bool,
	isLoadingProductionListWithPartsInvoicingToExport: PropTypes.bool,
	keyword: PropTypes.string,
	setKeyword: PropTypes.func,
	suppliers: PropTypes.array,
	setCurrentPage: PropTypes.func,
	isSupplier: PropTypes.bool,
	selectedSupplier: PropTypes.string,
	productionListWithPartsInvoicing: PropTypes.array,
	productionListWithPartsInvoicingToExport: PropTypes.array,
	getFilteredProductionsWithPartsInvocingToExport: PropTypes.func,
	removeFilteredProductionsWithPartsInvocingToExport: PropTypes.func,
	roles: PropTypes.arrayOf(PropTypes.string),
	totalImport: PropTypes.number,

}

const mapStateToProps = (state) => ({
	suppliers: state.Users.suppliers,
	productionListWithPartsInvoicing: state.Productions.productionListWithPartsInvoicing,
	productionListWithPartsInvoicingToExport: state.Productions.productionListWithPartsInvoicingToExport,
	isLoadingProductionListWithPartsInvoicing: state.Productions.isLoadingProductionListWithPartsInvoicing,
	isLoadingProductionListWithPartsInvoicingToExport: state.Productions.isLoadingProductionListWithPartsInvoicingToExport,
	roles: state.Login.roles
})

const mapDispatchToProps = {
	getFilteredProductionsWithPartsInvocingToExport,
	removeFilteredProductionsWithPartsInvocingToExport
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FilterProductionListWihPartsModal))
